<template>
    <div class="row justify-content-center">

        <EmailRegister/>

        <div class="col-12">
            <div class="personal-notice text-center" v-if="flavorConfig.personalDataNotice">
                * {{ $t('personal_data_agree') }}
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12">
                <div class="row mt-1 justify-content-center">
                    <SocialLogin/>
                </div>
            </div>
            <div class="col-12 text-center other-login">
                <router-link :to="recoveryLink()" class="text-light">
                    {{ $t('forgot_password') }}
                </router-link>
            </div>
            <div class="col-12 text-center mt-2 other-login">
                <router-link to="/user/signin" class="text-light">
                    {{ $t('login_existing_account') }}
                </router-link>
            </div>
        </div>

    </div>
</template>
<script>
    import SocialLogin from "./SocialLogin";
    import EmailRegister from "./Auth/EmailRegister";


    export default {
        name: 'user-register',
        components: {EmailRegister, SocialLogin},
        data() {
            return {}
        },
        methods: {
            recoveryLink() {
                if ('return' in this.$route.query) return '/user/recovery?return=' + this.$route.query.return
                return '/user/recovery'
            }
        }
    }
</script>
<style scoped>
</style>
